module.exports = "/images/mix-contract.svg?fa6f9d8acc969726339b55c6d181c540";